import { BaseBanner } from './BaseBanner';

class MainBanner extends BaseBanner {}

export { MainBanner };



// WEBPACK FOOTER //
// ./src/models/MainBanner.js